<template>
    <oss-dialog
        v-model="dialog"
        :title="companyType === 'CUSTOMER' ? 'Client' : 'Fournisseur'"
        @close="close()"
        width="800px"
    >
        <v-row no-gutters class="mt-2" v-if="activateFreeTag">
            <v-col>
                <FreeTag
                    :companyTags="allCompanyTags"
                    :company="selectedCompany"
                    :createIfMissing="true"
                    @onTagsChanged="onTagsChanged"
                />
            </v-col>
        </v-row>
        <!-- <v-row  no-gutters class="ml-1 mt-2">
                <v-col>
                    <v-switch inset dense v-model="consumer" class="my-0" color="secondary" :label="'Particulier'" v-if="companyType === 'CUSTOMER'"></v-switch>
                </v-col>
            </v-row> -->

        <CompaniesTable
            :showGenericCompany="companyType === 'SUPPLIER'"
            :showSupplierCompanies="companyType === 'SUPPLIER'"
            :showConsumerCompany="companyType === 'CUSTOMER'"
            :showCustomerCompanies="companyType === 'CUSTOMER'"
            :showExistingCompanies="false"
            :parentCompanyId="companyId"
            :company="companyName"
            :wizardMode="true"
            @select-company="setThirdPartyCompany"
        />

        <template v-slot:actions>
            <v-row no-gutters>
                <v-col cols="6" v-if="thirdPartyCompanyAlreadyDefined">
                    <v-btn-primary block @click="validate" :loading="loading" size="x-large"
                        >Retirer
                    </v-btn-primary>
                </v-col>
                <v-col :cols="thirdPartyCompanyAlreadyDefined ? 6 : 12">
                    <v-btn-primary
                        block
                        @click="validate"
                        :loading="loading"
                        :disabled="!thirdPartyCompany"
                        size="x-large"
                        >Valider</v-btn-primary
                    >
                </v-col>
            </v-row>
        </template>
    </oss-dialog>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";

import CompaniesTable from "../admin/CompaniesTable.vue";
import FreeTag from "../tag/FreeTag.vue";

import UPDATE_BANKTRANSACTION_ACCOUNTINGLINES from "../../graphql/bankTransaction/UpdateBankTransactionAccountingLines.gql";

import { createCompany } from "../../services/companyServices";
// import { computeNotJustifiedAmountSigned, computeJustifiedNotJustified } from "../../services/bankTransactionServices";
import { ComponentBase } from "../ComponentBase";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";

// import { computeDebitCredit } from "../../../../backend/src/common/accountingLine/accountingLineServices";
// import { getConnectAccountableAccount } from "../../services/accountableAccountServices";

@Component({
    components: {
        CompaniesTable,
        FreeTag,
    },
    emits: ["added", "cancel"],
})
export class ThirdPartyCompany extends ComponentBase {
    @Model() value: boolean;
    @Prop({ default: null }) step: any;
    @Prop({ default: null }) btItem: any;
    @Prop({ default: null }) bankTransactions: any;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "SUPPLIER" }) companyType: string;

    @Prop({ default: false }) activateFreeTag: boolean;

    loading: boolean = false;

    thirdPartyCompany = null;

    get activateTagguing() {
        return this.activateFreeTag;
    }

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        this.value = event;
    }

    get bankTransaction() {
        if (this.btItem) {
            return this.btItem.bt;
        }
        return null;
    }

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    async validate() {
        this.loading = true;
        const bankTransactions = this.bankTransaction
            ? [this.bankTransaction]
            : this.bankTransactions;
        if (this.thirdPartyCompany && !this.thirdPartyCompany.id) {
            this.thirdPartyCompany.id = await createCompany(this.$apollo, this.thirdPartyCompany);
        }
        const promises = [];
        if (bankTransactions && bankTransactions.length) {
            for (const bankTransaction of bankTransactions) {
                // let notJustifiedAmountSigned = computeNotJustifiedAmountSigned(bankTransaction, bankTransaction.accountingLines)
                const variables: any = {
                    id: bankTransaction.id,
                    accountingLines: [],
                    // notJustifiedAmountSigned: 0,
                    // justifiedAmountSigned: 0,
                    toDeleteAccountingLineIds: [],
                };
                if (this.btItem && this.btItem.accountingLine.id) {
                    // variables.toDeleteAccountingLineIds = [{ id: this.btItem.accountingLine.id }]
                    variables.toDeleteAccountingLineIds = [this.btItem.accountingLine.id];
                    // notJustifiedAmountSigned -= this.btItem.accountingLine.amountSigned
                }

                if (this.thirdPartyCompany) {
                    const amountSigned = this.btItem
                        ? this.btItem.accountingLine.amountSigned
                        : -bankTransaction.amount;
                    const al = {
                        // company: {connect: {id: this.companyId}},
                        // wording: bankTransaction.wordingDisplay || bankTransaction.wordingOriginal,
                        // date: bankTransaction.dateDebit,
                        amountSigned,
                        // amount: Math.abs(amountSigned),
                        accountableAccountName:
                            this.companyType === "SUPPLIER" ? "401000" : "411000",
                        thirdPartyCompanyId: this.thirdPartyCompany.id,
                        tagIds: this.tags.length ? this.tags.map((t) => ({ id: t.id })) : undefined,
                    };
                    // computeDebitCredit(al)
                    variables.accountingLines.push(al);
                    // notJustifiedAmountSigned += amountSigned
                }
                // computeJustifiedNotJustified(bankTransaction.amount, notJustifiedAmountSigned, variables)

                promises.push(
                    this.$apollo.mutate({
                        mutation: UPDATE_BANKTRANSACTION_ACCOUNTINGLINES,
                        variables: variables,
                    }),
                );
            }
        }
        if (promises.length) {
            await Promise.all(promises);
        }
        this.thirdPartyCompany = null;
        this.$emit("added");
        this.loading = false;
    }

    close() {
        this.thirdPartyCompany = null;
        // this.$emit('cancel');
    }

    async setThirdPartyCompany(company) {
        this.thirdPartyCompany = company;
    }

    @Apollo(
        {
            query: gql`
                query consumerCompany {
                    companies(where: { type: CONSUMER }) {
                        id
                        name
                    }
                }
            `,
            skip() {
                return this.companyType !== "CUSTOMER";
            },
        },
        (data) => (data && data.companies && data.companies.length ? data.companies[0] : null),
    )
    consumerCompany: any = null;

    // get consumer() {
    //     // debugger
    //     return this.thirdPartyCompany && this.consumerCompany && this.thirdPartyCompany.id === this.consumerCompany.id
    // }

    // set consumer(value) {
    //     debugger
    //     if (value) {
    //         this.thirdPartyCompany = JSON.parse(JSON.stringify(this.consumerCompany))
    //     } else {
    //         this.thirdPartyCompany = null;
    //     }
    // }

    getThirdPartyCompanyFromBT(bankTransaction) {
        if (
            bankTransaction &&
            bankTransaction.accountingLines &&
            bankTransaction.accountingLines.length
        ) {
            for (const al of bankTransaction.accountingLines) {
                if (al.thirdPartyCompany) {
                    return al.thirdPartyCompany;
                }
            }
        }
        return null;
    }

    get thirdPartyCompanyFromBT() {
        return this.getThirdPartyCompanyFromBT(this.bankTransaction);
    }

    get thirdPartyCompanyAlreadyDefined() {
        if (this.thirdPartyCompanyFromBT) return true;
        if (this.bankTransactions) {
            for (const bankTransaction of this.bankTransactions) {
                if (this.getThirdPartyCompanyFromBT(bankTransaction)) {
                    return true;
                }
            }
        }
        return false;
    }

    get companyName() {
        if (this.thirdPartyCompany)
            return this.thirdPartyCompany.shortName || this.thirdPartyCompany.name;
        if (this.thirdPartyCompanyFromBT)
            return this.thirdPartyCompanyFromBT.shortName || this.thirdPartyCompanyFromBT.name;
        return "";
    }

    //
    // tag management
    //

    tags = [];

    onTagsChanged(data) {
        this.tags = data.tags;
    }
}

export default toNative(ThirdPartyCompany);
</script>
